<template>
  <div class="py-2 is-flex">
    <up-label :label="label" :labelIcon="labelIcon"></up-label>
    <input
      class="px-2"
      v-model.number="label_input"
      :style="`width: ${sizeOfInputField}rem`"
      type="number"
      ref="colorinput"
      @focus="randomColor()"
      @blur="defaultColor()"
    />
  </div>
</template>

<script>
import UpLabel from "../Label";
import { addRandomBorderColor } from "./RandomColor.js";
export default {
  name: "up-numberinput",
  props: {
    value: {
      type: Number,
    },
    label: {
      type: String,
    },
    labelIcon: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "sm",
    },
  },
  components: {
    UpLabel,
  },
  data() {
    return {
      label_input: this.value ? this.value : 0,
      randColor: addRandomBorderColor,
    };
  },
  methods: {
    randomColor() {
      let color = this.randColor();

      let input_element = this.$refs.colorinput;
      input_element.style.border = `2px solid ${color}`;
    },
    defaultColor() {
      let input_element = this.$refs.colorinput;
      input_element.style.border = "2px solid black";
    },
  },
  computed: {
    sizeOfInputField() {
      let sizes = { xs: 4, sm: 6, md: 8, lg: 10, xl: 12 };
      if (sizes[this.size]) {
        return sizes[this.size];
      } else {
        return 5;
      }
    },
  },
  watch: {
    label_input: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.label_input = new_val;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
input {
  height: 1.7rem;
  border: 2px solid black;
}
input:focus,
input:hover {
  outline: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
